<template>
  <div class="error-message">
    <div>
      <svg>
        <use :xlink:href="'/assets/public/images/icons.svg#error'" />
      </svg>
      <div>
        <p>Sorry, we couldn’t find any product recommendations.</p>
        <p>
          Go back to
          <a href @click.prevent="jumpToField(1, 'name')" aria-label="change my details">Change my details</a>, or tell us what happened. Our friendly team will be happy to help
          you.
        </p>
      </div>

      <a class="button crimson" href="/support/contact-us" aria-label="link to contact us page" target="_blank">Contact us</a>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    jumpToField(step, field, clickedText = undefined) {
      if (typeof this.$parent.jumpToField === 'function') {
        this.$parent.jumpToField(step, field, clickedText);
      } else {
        this.$parent.$parent.jumpToField(step, field, clickedText);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@general/styles/_constants.scss';
@import '@general/styles/_responsive_mixins.scss';
@import '@general/styles/_flex.scss';

.error-message {
  @include flex-col;
  @include flex-center-all;
  padding: rem(60) 0;
  margin: 0;

  svg {
    width: rem(28);
    height: rem(28);
    padding-bottom: rem(30);
  }

  p {
    text-align: center;

    &:last-of-type {
      margin-bottom: rem(30);
    }
  }

  & > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: rem(630);
    width: auto;
    padding: 0 rem(25);
  }
}
</style>
